<script>
import { cloneDeep, isNil, get } from 'lodash'
import moment from 'moment'

export default {
  inheritAttrs: false,
  model: {
  },
  props: {
    exportExcelTemplate: {
      type: Object,
      default: () => {}
    },
    list: {
      type: Array,
      default: () => []
    },
    fileName: {
      type: String,
      default: 'export'
    },
    addDate: {
      type: String,
      default: null
    },
    height: {
      type: String,
      default: '42px'
    },
    cssClass: {
      type: String,
      default: 'el-icon-download'
    },
    type: {
      type: String,
      default: 'primary'
    }
  },
  methods: {
    handleExportExcel() {
      import('@/vendor/Export2Excel').then(excel => {
        const header = this.exportExcelTemplate.header
        const list = cloneDeep(this.list)
        if (this.exportExcelTemplate.arrJson && this.exportExcelTemplate.arrJson.length > 0) {
          list.forEach(item => {
            this.exportExcelTemplate.arrJson.forEach(field => {
              if (item[field]) {
                item[field] = JSON.stringify(item[field])
              }
            })
          })
        }
        const data = this.formatJson(this.exportExcelTemplate.filterVal, list)
        let fileName = this.fileName
        if (this.addDate && this.addDate !== '') {
          fileName += '_' + moment(new Date()).format(this.addDate)
        }
        excel.export_json_to_excel({
          header,
          data,
          filename: fileName,
          autoWidth: true,
          bookType: 'xlsx'
        })
      })
    },
    formatJson(filterVal, jsonData) {
      if (!filterVal || !jsonData) {
        return []
      }
      return jsonData.map(v => filterVal.map(j => {
        const xj = j.split('@')
        const formatType = xj[1]
        let val

        // Handle special formats that need custom path processing
        if (formatType === 'fraction' || formatType === 'average') {
          const fields = xj[0].split('/')
          const num = get(v, fields[0]) || 0
          const denom = get(v, fields[1]) || 0

          if (formatType === 'fraction') {
            // Display as "5 / 10" (string format, not calculation)
            return `${num} / ${denom}`
          } else {
            // Calculate average and display as "75 / 100" (rounded to integer)
            const avg = denom > 0 ? (num / denom).toFixed(0) : '0'
            return `${avg} / 100`
          }
        }

        // Handle coalesce format (fallback paths)
        if (formatType === 'coalesce') {
          const paths = xj[0].split('|')
          for (const path of paths) {
            const tempVal = get(v, path)
            if (!isNil(tempVal) && tempVal !== '') {
              return tempVal
            }
          }
          return ''
        }

        // Get value for other formats
        val = get(v, xj[0])

        // Handle null/undefined values
        if (isNil(val)) {
          return formatType === 'number' ? 0 : ''
        }

        // Apply format transformations
        switch (formatType) {
          case 'dateTime':
            val = moment(val).format('hh:mm DD-MM-YYYY')
            break
          case 'date':
            val = moment(val).format('DD-MM-YYYY')
            break
          case 'gender':
            val = val === 0 ? 'Nam' : val === 1 ? 'Nữ' : ''
            break
          case 'boolean':
            val = val ? 'Có' : 'Không'
            break
          case 'avatar':
            // Generate avatar URL from eID
            val = `https://shelton-statics.sgp1.digitaloceanspaces.com/easy_id/avatars/${encodeURIComponent(val)}.jpg`
            break
        }

        return val
      }))
    }
  }
}
</script>

<template>
  <el-button
        size="mini"
        :class="cssClass"
        :type="type"
        @click="handleExportExcel"
        :style="'height:' + height"
      >
      </el-button>
</template>

<style lang="scss">
.base-export-excel{
}
@media only screen and (max-width: 320px) {

}
@media only screen and (max-width: 480px) {

}
@media only screen and (max-width: 600px) {

}
@media only screen and (max-width: 768px) {

}
@media only screen and (max-width: 900px) {

}
@media only screen and (max-width: 1024px) {

}
</style>
